import Vue from 'vue';

Vue.filter('asLowerCase', (text) => String(text).toLowerCase());
